import { render } from "./SettingTab.vue?vue&type=template&id=11ea0e76&scoped=true"
import script from "./SettingTab.vue?vue&type=script&lang=js"
export * from "./SettingTab.vue?vue&type=script&lang=js"

import "./SettingTab.vue?vue&type=style&index=0&id=11ea0e76&lang=scss&scoped=true"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ea0e76"]])

export default __exports__